import Vue from 'vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue';
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
import axios from "axios";
import JsonExcel from 'vue-json-excel'
import vSelect from 'vue-select'
import Header from "../../components/Header.vue";

Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select', vSelect)

export default {
    components: {
        Header,
        Vuetable,
        VuetablePagination,
        VuetableFieldCheckbox,
        VuetableFieldMixin
    },
    data: function() {
        return {
            pageTitle: "Groupe d'utilisateur",
            logo: null,
            show_progress: false,
            valeur_progression: 0,
            groupeUtilisateur: [],
            selectedGroupId: '',
            nomGroupeSelectionne: '',
            searchQuery: '',
            crudform: {
                id: "",
                nom: "",
                nom_groupe: "",
                etat_suppression: ""
            },
            crudmodaltitle: "Ajouter ",
            listdata: {
                magasins: [],
                pointventes: []
            },
            error_password: "",
            allacces: [],
            isSaving: false
        }
    },
    methods: {
        // Fonction pour normaliser les chaînes et ignorer les accents
        normalizeString(str) {
            if (!str) return '';
            return str
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim();
        },

        // Sélectionner/désélectionner tous les accès d'un module
        toggleModule(module) {
            // Déterminer le nouvel état (si tous sont cochés, on décoche, sinon on coche tout)
            const allChecked = this.isModuleFullyChecked(module);
            const newState = allChecked ? 0 : 1;

            // Appliquer à tous les sous-modules et accès
            module.sous_modules.forEach(sm => {
                sm.list_acces.forEach(acc => {
                    acc.etat = newState;
                });
            });
        },

        // Sélectionner/désélectionner tous les accès d'un sous-module
        toggleSousModule(sousModule) {
            // Déterminer le nouvel état
            const allChecked = this.isSousModuleFullyChecked(sousModule);
            const newState = allChecked ? 0 : 1;

            // Appliquer à tous les accès
            sousModule.list_acces.forEach(acc => {
                acc.etat = newState;
            });
        },

        // Vérifier si tous les accès d'un module sont cochés
        isModuleFullyChecked(module) {
            return module.sous_modules.every(sm =>
                sm.list_acces.every(acc => acc.etat == 1)
            );
        },

        // Vérifier si certains accès d'un module sont cochés (état indéterminé)
        isModulePartiallyChecked(module) {
            const hasChecked = module.sous_modules.some(sm =>
                sm.list_acces.some(acc => acc.etat == 1)
            );
            const allChecked = this.isModuleFullyChecked(module);
            return hasChecked && !allChecked;
        },

        // Vérifier si tous les accès d'un sous-module sont cochés
        isSousModuleFullyChecked(sousModule) {
            return sousModule.list_acces.every(acc => acc.etat == 1);
        },

        // Vérifier si certains accès d'un sous-module sont cochés (état indéterminé)
        isSousModulePartiallyChecked(sousModule) {
            const hasChecked = sousModule.list_acces.some(acc => acc.etat == 1);
            const allChecked = this.isSousModuleFullyChecked(sousModule);
            return hasChecked && !allChecked;
        },

        fetchAllAcces() {
            axios
                .get(this.BASE_URL + "/groupeutilisateur/fetchelement")
                .then((response) => {
                    console.log(response.data);
                    this.allacces = response.data;
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        chargeAcces(idGroupe) {
            if (!idGroupe) {
                this.allacces = [];
                return;
            }

            let formulaire = new FormData();
            formulaire.append('nom_groupe', this.nomGroupeSelectionne);

            axios.post(`${this.BASE_URL}/groupeutilisateur/fetchelement`, formulaire)
                .then(response => {
                    this.allacces = response.data;
                    this.searchQuery = '';
                })
                .catch(error => {
                    console.error("Erreur chargement:", error);
                    Vue.$toast.open({
                        message: 'Erreur lors du chargement des accès',
                        type: 'error',
                        position: 'top-right'
                    });
                });
        },

        fetchGroupUser() {
            axios
                .get(this.BASE_URL + "/groupeutilisateur/fetchdata")
                .then((response) => {
                    console.log(response.data);
                    this.groupeUtilisateur = response.data;
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        onLoading() {
            console.log('loading... show your spinner here')
        },

        onLoaded() {
            console.log('loaded! .. hide your spinner here');
        },

        onSubmit() {
            var that = this;

            /*if (!this.nomGroupeSelectionne) {
                Vue.$toast.open({
                    message: 'Veuillez sélectionner un groupe d\'utilisateur',
                    type: 'warning',
                    position: 'top-right'
                });
                return;
            }*/

            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment enregistrer les modifications?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Enregistrer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value == true) {
                        that.isSaving = true;

                        let formulaire = new FormData();
                        formulaire.append('nom_groupe', that.nomGroupeSelectionne);
                        formulaire.append('acces', JSON.stringify(that.allacces));

                        var link = that.BASE_URL + "/groupeutilisateur/updateacces";

                        axios.post(link, formulaire)
                            .then(function(response) {
                                that.isSaving = false;
                                console.log(response);

                                if (response.data.error === "") {
                                    Vue.$toast.open({
                                        message: response.data.message,
                                        type: 'success',
                                        position: 'top-right',
                                        duration: 3000
                                    });

                                    that.chargeAcces(that.nomGroupeSelectionne);
                                } else {
                                    console.log("Erreur");
                                    Vue.$toast.open({
                                        message: response.data.error,
                                        type: 'error',
                                        position: 'top-right'
                                    });
                                }
                            })
                            .catch(function(error) {
                                that.isSaving = false;
                                console.error(error);
                                Vue.$toast.open({
                                    message: 'Erreur lors de l\'enregistrement',
                                    type: 'error',
                                    position: 'top-right'
                                });
                            });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },

        clearSearch() {
            this.searchQuery = '';
        },

        getTotalAccesCount() {
            let total = 0;
            this.allacces.forEach(module => {
                module.sous_modules.forEach(sm => {
                    total += sm.list_acces.length;
                });
            });
            return total;
        },

        getActiveAccesCount() {
            let active = 0;
            this.allacces.forEach(module => {
                module.sous_modules.forEach(sm => {
                    sm.list_acces.forEach(acc => {
                        if (acc.etat == 1) active++;
                    });
                });
            });
            return active;
        }
    },

    computed: {
        filteredAcces() {
            if (!this.searchQuery || this.searchQuery.trim() === '') {
                return this.allacces;
            }

            const normalizedQuery = this.normalizeString(this.searchQuery.trim());

            return this.allacces.map(module => {
                const moduleMatch = this.normalizeString(module.nom_module).includes(normalizedQuery);

                const filteredSousModules = module.sous_modules.map(sm => {
                    const sousModuleMatch = this.normalizeString(sm.sous_module).includes(normalizedQuery);

                    const filteredAcces = sm.list_acces.filter(acc => {
                        return this.normalizeString(acc.nom_acces).includes(normalizedQuery);
                    });

                    if (sousModuleMatch || filteredAcces.length > 0) {
                        return {
                            ...sm,
                            list_acces: sousModuleMatch ? sm.list_acces : filteredAcces
                        };
                    }
                    return null;
                }).filter(sm => sm !== null);

                if (moduleMatch || filteredSousModules.length > 0) {
                    return {
                        ...module,
                        sous_modules: moduleMatch ? module.sous_modules : filteredSousModules
                    };
                }
                return null;
            }).filter(module => module !== null);
        },

        filteredCount() {
            let count = 0;
            this.filteredAcces.forEach(module => {
                module.sous_modules.forEach(sm => {
                    count += sm.list_acces.length;
                });
            });
            return count;
        },

        hasSearchResults() {
            return this.searchQuery && this.filteredCount > 0;
        },

        noSearchResults() {
            return this.searchQuery && this.filteredCount === 0;
        }
    },

    created: function() {
        this.$emit('change-page', this.pageTitle);
        this.motCle = "";
        this.criteriacol = "";
    },

    mounted: function() {
        console.log(process);
        console.log(process.env);
        console.log(process.env.STRIPE_TOKEN);
        this.fetchGroupUser();
        this.fetchAllAcces();
    }
}